import { Grid2 } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { CompletenesWrapper } from '../completenes-wrapper';
import * as Styled from './styles';
import * as SX from './sx';
import type {
  CompletenesScore,
  CompletenessScoreProps as Props,
} from './types';
import { ItemCard } from '../item-card';

export const CompletenessScore = memo(({ className }: Props) => {
  const contactScores: CompletenesScore[] = [
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'Last name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
  ];

  const companyScores: CompletenesScore[] = [
    {
      name: 'Name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
    {
      name: 'First name',
      score: 945,
    },
  ];

  return (
    <Styled.Wrapper
      className={classnames('CompletenessScore', className)}
      sx={SX.root}
    >
      <ItemCard title="Completeness Score">
        <Grid2 container columns={12} sx={SX.content} columnSpacing={2.5}>
          <Grid2 xs={4}>
            <CompletenesWrapper items={contactScores} isPeople />
          </Grid2>
          <Grid2 xs={4}>
            <CompletenesWrapper items={companyScores.slice(0, 8)} />
          </Grid2>
          <Grid2 xs={4}>
            <CompletenesWrapper items={companyScores.slice(8, 15)} />
          </Grid2>
        </Grid2>
      </ItemCard>
    </Styled.Wrapper>
  );
});

CompletenessScore.displayName = 'CompletenessScore';
